export default __webpack_public_path__ + "static/media/poster-03.d0db0d8f.png";